import { render, staticRenderFns } from "./TransactionWrapper.vue?vue&type=template&id=15a740d5&"
import script from "./TransactionWrapper.vue?vue&type=script&lang=ts&"
export * from "./TransactionWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports